import { CheckSessionTimeout } from "./CheckSessionTimeout";
import { fetchWithTimeout } from "./Timeout";

export async function UploadCsvFile(file) {
    const Token = sessionStorage.getItem("Token");
    const header = { Authorization: `Bearer ${Token}` };

    var raw = JSON.stringify({
        session_id: Token,
        file: file,
    });

    console.log("raw",raw)

    var requestOptions = {
        method: "POST",
        body: raw,
        redirect: "follow",
        headers: header
    };

    if (!CheckSessionTimeout(Token)){
        try {
            const response = await fetchWithTimeout(
                process.env.REACT_APP_ONBOARD_ADVISOR_CSV_API,
                requestOptions
            );
            const message = await response.json();
            if (!response.ok) {
                return { status: response.status, error: message.error || message };
            } else {
                return { status: response.status, result: message.result };
            }
        } catch (error) {
            return { status: 0, error: error.message };
        }
    } else {
        return { status: 401 };
    }
}
